import en from './vlocStrings.en';

export default {
  en,
};
